import { Provider } from "react-redux";
import BlogList from "./components/BlogList";
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";
import Search from "./components/Search";
import { store } from "./redux/store";

function App() {
  return (
    <Provider store = {store}>
       <Navigation />

        <Search />

        <BlogList />

        <Footer />
      
    </Provider>
  );
}

export default App;
